/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

export const PTButtonWrapper = styled.div`
  margin-left: 5px;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  :hover {
    border: 1px solid ${(props) => props.theme.text.subtle};
  }
`;

export const StyledLockButton = styled.div<{ isPublic: boolean }>`
  width: 20px;
  height: 20px;
  margin-right: 5px;
  color: ${({ theme, isPublic }) => (isPublic ? theme.block.border : theme.accent)};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  :hover {
    filter: brightness(0.8);
  }
`;
